import MasterService from "./MasterService";

export const CommonService = {
	...MasterService, 
	
	// getList() {
	// 	return this.get("/common/list");
	// }, 
};
